const Select = {
  EN: {
    label: {
      select: 'SELECT PROJECT',
      project: 'Project',
    },
    button: {
      add: 'ADD NEW PROJECT',
    },
  },
  TH: {
    label: {
      select: 'เลือกโปรเจค',
      project: 'โปรเจค',
    },
    button: {
      add: 'เพิ่มโปรเจคใหม่',
    },
  },
};

export default Select;
